module.exports = __webpack_public_path__ + "static/media/eva_eye-outline.1c950a4d.svg";